import React from "react";
import PT from "prop-types";
import classnames from "classnames";
import styles from "./Button.module.scss";

interface ButtonProps
  extends React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  className?: string;
}

const Button: React.FC<ButtonProps> = ({ className, children, ...other }) => (
  <button
    type="button"
    className={classnames(styles.button, className)}
    {...other}
  >
    {children}
  </button>
);

Button.propTypes = {
  children: PT.node.isRequired,
  className: PT.string
};

Button.defaultProps = {
  className: ""
};

export default Button;
